import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import pt_BR from "./locales/pt_BR.json";
import pt_PT from "./locales/pt_PT.json";
import es from "./locales/es.json";
import us from "./locales/us.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import it from "./locales/it.json";
import ja from "./locales/ja.json";
import zh from "./locales/zh.json";
import ar from "./locales/ar.json";

const SAVED_LANGUAGE = localStorage.getItem("language") == "pt" ? "pt_BR" : (localStorage.getItem("language") || "pt_BR");
const FALLBACK_LANGUAGE = "pt_BR";

export const languages = [
    { code: "pt_BR", name: "Português", key: "settings.languages.pt_BR", file: pt_BR },
    { code: "pt_PT", name: "Português (Portugal)", key: "settings.languages.pt_PT", file: pt_PT },
    { code: "es", name: "Español", key: "settings.languages.es", file: es },
    { code: "us", name: "English", key: "settings.languages.us", file: us },
    { code: "fr", name: "Français", key: "settings.languages.fr", file: fr },
    { code: "de", name: "Deutsch", key: "settings.languages.de", file: de },
    { code: "it", name: "Italiano", key: "settings.languages.it", file: it },
    { code: "ja", name: "Japonês", key: "settings.languages.ja", file: ja },
    { code: "zh", name: "Chinês Simplificado", key: "settings.languages.zh", file: zh },
    { code: "ar", name: "Árabe", key: "settings.languages.ar", file: ar }
];

i18n.use(initReactI18next).init({
  resources: languages.reduce((acc, lang) => {
    acc[lang.code] = { translation: lang.file };
    return acc;
  }, {} as Record<string, { translation: Record<string, unknown> }>),
  lng: SAVED_LANGUAGE, // idioma padrão
  fallbackLng: FALLBACK_LANGUAGE,
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
